import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
`;

export const Title = styled.h1`
  font-size: 2rem;
  margin-bottom: 1rem;
`;

export const Message = styled.p`
  font-size: 1rem;
  color: gray;
`;

export const ButtonComponent = styled.div`
  display: flex;
  gap: 5px;
  justify-content: center;
  align-items: center;
`;
